import { cn } from "@/lib/utils";

/** A decorative row of beads — the chama circle, unrolled. */
export function BeadDivider({ className }: { className?: string }) {
  const colors = ["fill-primary", "fill-gold", "fill-accent"];
  return (
    <div
      aria-hidden="true"
      className={cn("flex items-center justify-center gap-2", className)}
    >
      {Array.from({ length: 7 }, (_, i) => (
        <svg key={i} viewBox="0 0 10 10" className="size-2.5">
          <circle cx="5" cy="5" r="4" className={colors[i % colors.length]} />
        </svg>
      ))}
    </div>
  );
}

/**
 * A geometric Maasai-shuka-inspired pattern band, used as a decorative hero
 * surface. Pure SVG; colors follow the theme.
 */
export function ShukaPattern({ className }: { className?: string }) {
  const row = (y: number, color: string, opacity = 1) =>
    Array.from({ length: 12 }, (_, i) => (
      <path
        key={`${y}-${i}`}
        d={`M ${i * 30} ${y} l 15 -14 l 15 14 l -15 14 Z`}
        className={color}
        opacity={opacity}
      />
    ));
  return (
    <svg
      viewBox="0 0 360 200"
      preserveAspectRatio="xMidYMid slice"
      className={cn("h-full w-full", className)}
      aria-hidden="true"
    >
      <rect width="360" height="200" className="fill-primary" />
      <g>{row(40, "fill-gold", 0.9)}</g>
      <g>{row(80, "fill-primary-foreground", 0.25)}</g>
      <g>{row(120, "fill-accent", 0.85)}</g>
      <g>{row(160, "fill-gold", 0.7)}</g>
      <g>
        {Array.from({ length: 24 }, (_, i) => (
          <circle
            key={`dot-${i}`}
            cx={15 + i * 15}
            cy={8}
            r={3}
            className="fill-primary-foreground"
            opacity={0.5}
          />
        ))}
        {Array.from({ length: 24 }, (_, i) => (
          <circle
            key={`dotb-${i}`}
            cx={15 + i * 15}
            cy={192}
            r={3}
            className="fill-primary-foreground"
            opacity={0.5}
          />
        ))}
      </g>
    </svg>
  );
}
